import { Button, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectPublico from "../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import { useState } from "react";
import SelectTipoDocPagar from "../../../../../../../components/SelectsSimpleApiQuery/SelectTipoDocPagar";
import axiosClient from "../../../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import { useMutation } from "react-query";


export default function Step01() {

  const {
    getValues,
    control,
    handleSubmit,
    setValue,
    setError,
    watch,
    clearErrors,
  } = useFormContext()

  const publicoDado = watch("step01.publico_dado");
  const handleNext = getValues('funcoesAux.onNext')

  const [isFocused, setIsFocused] = useState(false);

  const handleValidateInputs = (data: any) => {
    const { step01 } = data
    const situacaoFinanceira = step01.publico_dado.situacao_financeira
    if (situacaoFinanceira && situacaoFinanceira !== "LIBERADO" && situacaoFinanceira !== "SEMPRE LIBERADO") {
      setError("step01.publico_dado", {
        message: `Público com status financeiro: ${situacaoFinanceira}`,
        type: 'error'
      });
      return false
    } else {
      clearErrors("step01.publico_dado");
    }

    return true;
  }

  const { mutateAsync: checkForDuplicateTitle } = useMutation({
    mutationKey: "verificar-duplicidade-titulo",
    mutationFn: (formData: any) => {
      const { publico_dado, numero_documento, serie } = formData;
      return axiosClient.get('/financeiro/contas-pagar/verificar-duplicidade', {
        params: {
          tipo_publico: publico_dado?.tipo_publico,
          codigo_publico: publico_dado?.codigo_publico,
          numero_documento: numero_documento,
          serie_documento: serie
        }
      });
    },
    onSuccess: (response) => {
      const data = response.data;
      if (data.mensagem && !data.mensagem.includes("Nenhum")) {
        enqueueSnackbar(data.mensagem, { variant: 'warning' });
      } else {
        handleNext();
      }
    },
    onError: () => {
      enqueueSnackbar("Erro ao verificar duplicidade", { variant: "error" });
    }
  });
  const handleNextStep = async (data: any) => {
    if (!handleValidateInputs(data)) return;
    checkForDuplicateTitle(data.step01);
  };


  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.publico_dado"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => {
            return (
              <SelectPublico
                {...field}
                error={invalid}
                required
                errorMessage={error?.message}
                value={field.value}
                onChange={(valor) => field.onChange(valor)}
              />
            )
          }}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.tipo_documento"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectTipoDocPagar
              {...field}
              required
              disabled={publicoDado === '' ? true : false}
              error={invalid}
              errorMessage={error?.message}
              extraParams={{ tipo_publico: publicoDado.tipo_publico, codigo_publico: publicoDado.codigo_publico }}
              value={field.value}
              onChange={(valor) => {
                field.onChange(valor)
                setValue('step01.numero_documento', valor?.sugestao_numero)
              }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.numero_documento"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              type="text"
              label="Número"
              required
              value={field.value}
              fullWidth
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '')
                field.onChange(value)
              }}
              inputProps={{ maxLength: 6, inputMode: "numeric", pattern: "[0-9]*" }}
              InputLabelProps={{ shrink: isFocused || Boolean(field.value) }}
              error={Boolean(error)}
              helperText={error ? "Campo obrigatório" : ""}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="step01.serie"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              label="Série"
              required
              value={field.value || ''}
              fullWidth
              onChange={(e) => field.onChange(e.target.value)}
              slotProps={{ htmlInput: { maxLength: 3 } }}
              error={Boolean(error)}
              helperText={error ? "Campo obrigatório" : ""}
            />
          )}
        />

      </Grid>
      <Grid size={{ xs: 12 }}>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          onClick={handleSubmit(handleNextStep)}
        >
          Avançar
        </Button>
      </Grid>
    </Grid>
  )
}